
































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http";
import { Menu } from "../../modules/Menu";
import * as Common from "../../commons/common";

export interface Data {
  errors: string[]
  loginId: string
  password: string
  school_id: string
  isPasswordShowable: boolean
};

export default defineComponent({
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: [],
      loginId: "",
      password: "",
      school_id: "",
      isPasswordShowable: false,
    });

    // ログインボタン押下
    const onSubmit = async () => {
      state.errors = [];
      if(state.loginId.length == 0){
        state.errors.push("ログインIDを入力してください。");
        return;
      }

      if(state.password.length == 0){
        state.errors.push("パスワードを入力してください。");
        return;
      }
      
      http.post("/api/login/student", {condition: {login_id: state.loginId, password: state.password, school_id: state.school_id}})
        .then(response => {
          executeLogin(response);
        })
        .catch(error=>{
          if (error.response.status == 401) {
            state.errors.push("ログインに失敗しました。ユーザIDまたはパスワードを確認してください。");
          }
          if (error.response.status == 403) {
            state.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
          }
          if (error.response.status == 405) {
            state.errors.push("ただいま生徒のアクセスが混みあっています。しばらく経ってからログインしてください。");
          }
          if (error.response.status == 406) {
            state.errors.push("現在メンテナンス中のためログインできません。");
          }
          if (error.response.status == 411) {
            state.errors.push("生徒のログインが無効になっています。");
          }
        });
    }

    // ログイン成功後の後処理
    const executeLogin = (response: any) => {
      var user = response.data.user;

      // トークン設定
      var token = user.access_token
      document.cookie = `access_token=${token}`;
      document.cookie = 'smarky_user_id=' + user.id;

      context.root.$store.commit("setCurrentUser", user);
      context.root.$store.commit("setCurriculums", response.data.curriculums);
      context.root.$store.commit("setStudentNoCharacter", response.data.student_no_character);

      // 初回ログインの場合はパスワード変更画面へ遷移、左記以外は試験一覧へ遷移
      context.root.$router.push(`/${state.school_id}/student_site/sheet_list`).catch(err => {});
    }

    /******************************
     * Googleログイン
     ******************************/

    const googleLogin = async () => {
      document.cookie = `school_id=${context.root.$route.params.school_id}`;
      window.location.href = `/api/classroom_sessions/authorize_sso?type=sso_student`;
    }

    /******************************
     * Windowsアカウントログイン
     ******************************/

    const azureLogin = async () => {
      document.cookie = `school_id=${context.root.$route.params.school_id}`;
      window.location.href = `/api/azure_sessions/authorize_sso?type=sso_student`;
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await http.get(`/api/master_data/school_logo_image?school_id=${context.root.$route.params.school_id}`).then(response => {
        if(response.data.base64_image == null){
          context.root.$store.commit("setBase64SchoolLogo", require("@/assets/images/logo_smarky_ol.png"));
        }else{
          context.root.$store.commit("setBase64SchoolLogo", `data:image/jpeg;base64,${response.data.base64_image}`);
        }

        if(context.root.$route.query.error_kind){
          const error_kind = context.root.$route.query.error_kind as string;

          if(error_kind == "user_not_exists"){
            state.errors.push("お試しいただいたGoogleアカウントではログインできません。");
          }else if(error_kind == "user_not_exists_azure"){
            state.errors.push("お試しいただいたMicrosoftアカウントではログインできません。");
          }else if(error_kind == "mainte"){
            state.errors.push("現在メンテナンス中のためログインできません。");
          }else if(error_kind == "student_mainte"){
            state.errors.push("現在メンテナンス中のため生徒アカウントはログインできません。");
          }else if(error_kind == "login_failed_not_active"){
            state.errors.push("アカウントが無効になっているためログインできません。");
          }else if(error_kind == "student_manage_not_active"){
            state.errors.push("生徒のログインが無効になっています。");
          }else if(error_kind == "student_manage_not_active_azure"){
            state.errors.push("生徒のログインが無効になっています。");
          }else if(error_kind == "multiple_login_count"){
            state.errors.push("ただいま生徒のアクセスが混みあっています。しばらく経ってからログインしてください。");
          }else if(error_kind == "login_failed_count_over"){
            state.errors.push("ログイン失敗回数の制限を超えたためログインできません。管理者に問い合わせてください。");
          }else{
            state.errors.push("ログインに失敗しました。予期せぬエラーが発生しました。");
          }
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          console.log(error.response.data.errors);
        }
      });
      state.school_id = context.root.$route.params.school_id;
      context.root.$store.commit("setIsHeaderDisp", false);
    })

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      onSubmit,
      googleLogin,
      azureLogin,
    }
  }
})
